/** Basis points as a percentage for display: 570 -> "5.70%". */
export function formatRate(basisPoints: number) {
  return `${(basisPoints / 100).toFixed(2)}%`
}
